export default (context) => {
    let is_validate = false
    if(context.phone && context.token) { is_validate = true }
    else { return context.$router.push('/auth-check-order') }


    if(is_validate) {
        context.$axios.post('getUserOrders', {
            phone: context.phone,
            tocken: context.token
        })
            .then(({ data }) => {
                if(data.success) {
                    context.orders = data.data
                    context.overlay = false
                    context.error.status = false
                    context.error.text = ''
                } else {
                    if(data.error === 'Неверная пара телефон + токен') {
                        context.$router.push('/auth-check-order')
                    } else {
                        context.overlay = true
                        context.error.status = true
                        context.error.text = data.error
                    }

                }
            })
            .catch(e => {
                console.error(e)
                context.error.text = 'Ошибка сервера! Не удалось получить список заказов. Повторите попытку позже.'
                context.overlay = true
                context.error.status = true
            })
    }
}